<template>

      <FormTest/>

</template>

<script>
import ViewSection from './components/view/View'
//import Form from './components/form/Form'
import FormTest from './components/form/FormTest'
import DownloadingBar from './components/downloading/DownloadingBar'

export default {
  name: 'app',
  components: {
    ViewSection,
    FormTest,
    DownloadingBar
  },
  computed: {
    checkTableStatus: function() {
      return this.$store.state.tableIsLoaded
    }
  }
}
</script>

<style>

html, body, #main {
  min-height: 100% !important;
  height: 100%;
  padding: 0px;
  margin: 0px;
  background-color: #fafafa;
} 

#main {
  display: grid;
  align-content: stretch; 
  grid-template-columns: 10px auto 10px;
  grid-template-rows: 145px 480px 60px; 
}

#view {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  margin-right: 15px;

  overflow: hidden;
  grid-column-start: 2;
  grid-column-end: 2;
  grid-row-start: 2;
  grid-row-end: 4;
}

#form {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 190px;
  overflow: hidden;
  grid-column-start: 2;
  grid-column-end: 2;
  grid-row-start: 1;
  grid-row-end: 2;

  border-radius: 0px 0px 0px 0px;
}

#downloading {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  overflow: hidden;
  grid-column-start: 2;
  grid-column-end: 2;
  grid-row-start: 3;
  grid-row-end: 3;

  
}
</style>
